export const BOOK_DEMO_SESSION_KEY = 'book_demo_email_approved';

const CONTACT_API_URL =
  process.env.REACT_APP_CONTACT_API_URL || 'https://5kdsze9xs4.execute-api.eu-central-1.amazonaws.com';

function syncBookDemoIntent(email: string) {
  const source = sessionStorage.getItem('lead_source') || 'direct';

  void fetch(`${CONTACT_API_URL}/book-demo-intent`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, source }),
    keepalive: true,
  }).catch(error => {
    console.error('Failed to sync book demo intent:', error);
  });
}

export function approveBookDemoEmail(email: string) {
  const normalizedEmail = email.trim().toLowerCase();
  sessionStorage.setItem(BOOK_DEMO_SESSION_KEY, normalizedEmail);
  syncBookDemoIntent(normalizedEmail);
}

export function getApprovedBookDemoEmail() {
  const value = sessionStorage.getItem(BOOK_DEMO_SESSION_KEY);
  if (!value || value === 'true') return null;
  return value;
}

export function isBookDemoEmailApproved() {
  return getApprovedBookDemoEmail() !== null;
}

export function clearBookDemoEmailApproval() {
  sessionStorage.removeItem(BOOK_DEMO_SESSION_KEY);
}
